$(document).ready(function () {
  const sectionId = document.querySelector('[data-section-id]')?.dataset.sectionId;
  const bundleData = document.querySelector('#bundle-config-data');
  const bundleId = bundleData?.dataset.bundleId;
  const discount = parseInt(bundleData?.dataset.discount || "0");
  const totalSteps = parseInt(bundleData?.dataset.totalSteps || "0");
  const currentTime = new Date().getTime();

  let state = {
    step: 1,
    totalSteps: totalSteps,
    items: []
  };

  let stateProxy = new Proxy(state, {
    set(target, property, value) {
      if (target[property] !== value) {
        target[property] = value;
        if (property === 'step') {
          navController.setNavToActive(value);
          collectionController.changeCollection();
        }
        if (property === 'items') {
          if (state.items.length == state.totalSteps) {
            collectionController.revealFinalPage();
          }
        
          navController.setNavToComplete(target.step);
          floatingCartController.renderCartSection();

          $('.floating-text').toggleClass('has-items', state.items.length > 0);
        }
      }
      return true;
    }
  });

  class NavigationController {
    constructor(stateProxy) {
      this.stateProxy = stateProxy;
    }

    get items() { return this.stateProxy.items; }
    get step() { return this.stateProxy.step; }
    get totalSteps() { return this.stateProxy.totalSteps; }

    resetNav() {
      $('.dot-custom-bundles').removeClass("active complete");
    }

    setNavToActive(stepNumber) {
      this.setNavToComplete();
      $('.dot').removeClass("active");
      $(`.dot[data-step="${stepNumber}"]`)
        .addClass('active')
        .removeClass('complete');
    }

    setNavToComplete() {
      this.items.forEach((x) => {
        $(`.dot[data-step="${x.step}"]`).addClass('complete').removeClass('active');
      });
    }
  }

  class CollectionController {
    constructor(stateProxy) {
      this.stateProxy = stateProxy;
    }

    get items() { return this.stateProxy.items; }
    set items(value) { this.stateProxy.items = value; }
    get step() { return this.stateProxy.step; }

    changeCollection() {
      $('.dot-list-wrapper').removeClass('d-none');
      $(".collection-outer").removeClass('d-none');
      $(".floating-text").removeClass('d-none');
    
      const currentStep = this.stateProxy.step;
      console.log("Showing step", currentStep);
    
      const allCollections = $('.collection-wrapper');
      const collectionToShow = $(`.collection-wrapper[data-step="${currentStep}"]`);
    
      allCollections.addClass('d-none').addClass('hidden-collection');
    
      collectionToShow.removeClass('d-none');
    
      setTimeout(() => {
        collectionToShow.removeClass('hidden-collection');
      }, 10);
    }

    revealFinalPage() {
      $('.collection-wrapper, .floating-text-custom-bundles').addClass('d-none hidden-collection');
    
      setTimeout(() => {
        $('#review-page').removeClass('d-none hidden-collection');
        $('.content-wrapper').addClass("complete");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        $('.collection-outer-custom-bundles').addClass('d-none');
      }, 300);
    }

    goBackToEdit() {
      $('#review-page').addClass('hidden-collection');
      $('.dot-list-wrapper, .collection-outer-custom-bundles, .floating-text-custom-bundles').removeClass('d-none');
      $('.content-wrapper').removeClass("complete");
    
      setTimeout(() => {
        $('#review-page').addClass('d-none');
        $('.collection-wrapper, .floating-text-custom-bundles').addClass('d-none hidden-collection');
    
        const currentStep = this.stateProxy.step;
        const collectionToShow = $(`.collection-wrapper[data-step="${currentStep}"]`);
        collectionToShow.removeClass('d-none hidden-collection');
      }, 200);
    }
  }

  class FloatingCartController {
    constructor(stateProxy) {
      this.stateProxy = stateProxy;
    }

    get items() { return this.stateProxy.items; }
    get step() { return this.stateProxy.step; }
    get totalSteps() { return this.stateProxy.totalSteps; }

    renderCartSection() {
      this.updateIntroTextDisplay();
      this.renderCartItems();
      this.updateCartTotals();
      this.updateAddToCartButton();
    }

    updateIntroTextDisplay() {
      $(".intro-text").toggleClass("d-none", this.items.length > 0);
    }

    renderCartItems() {
      $('.cart-items, #review-items-wrapper').empty();

      if (this.items.length === 0) {
        $('.cart-items').append(`<span class="intro-text text-m"></span>`);
        return;
      }

      this.items.forEach(item => {
        const html = `
          <div class="cart-item" data-product-id="${item.productId}">
            <div class="cart-item-wrapper gap-2">
            <img width="64" height="64" src="${item.image}" />
            <div class="cart-item-text-wrapper product-card__info text-start v-stack gap-1">
              <span class="step-label text-xs sm:text-sm">${item.stepText}</span>
              <span class="product-title text-sm sm:h6">${item.productTitle}</span>
              <span class="item-price">$${(item.productPrice / 100).toFixed(2)}</span>
            </div>
            </div>
            <button class="complete-edit-button link text-sm" data-step="${item.step}">Edit</button>
          </div>`;

        $('.cart-items, #review-items-wrapper').append(html);
      });
    }

    updateCartTotals() {
      let discountPercentage = discount / 100;
      let totalPrice = this.items.reduce((sum, item) => sum + parseInt(item.productPrice), 0);
      let discountedPrice = totalPrice * discountPercentage;

      $('.discounted-subtotal').text(`$${((totalPrice - discountedPrice) / 100).toFixed(2)}`);
      $('.subtotal').text(`$${(totalPrice / 100).toFixed(2)}`).removeClass("d-none");
      $('.savings').text(`$${(discountedPrice / 100).toFixed(2)}`);

      if (totalPrice === 0) {
        $('.subtotal, .savings').text("$00.00");
      }
    }

    updateAddToCartButton() {
      const btn = $('.add-to-cart');
      if (this.items.length === this.totalSteps) {
        btn.text("ADD KIT TO CART").removeClass("floating-add-to-cart-disabled");
      } else {
        btn.addClass("floating-add-to-cart-disabled");
        let remaining = this.totalSteps - this.items.length;
        btn.text(`ADD ${remaining} MORE PRODUCT${remaining > 1 ? 'S' : ''}`);
      }
    }
  }

  class StepController {
    constructor(stateProxy) {
      this.stateProxy = stateProxy;
    }

    get step() { return this.stateProxy.step; }
    set step(value) { this.stateProxy.step = value; }
    incrementStep() { this.setStep(this.step + 1); }
    decrementStep() { this.setStep(this.step - 1); }
    setStep(value) { this.step = value; }
  }

  const navController = new NavigationController(stateProxy);
  const collectionController = new CollectionController(stateProxy);
  const floatingCartController = new FloatingCartController(stateProxy);
  const stepController = new StepController(stateProxy);

  $('#back-button').click(() => stepController.decrementStep());

  $('.dot').click(function () {
    stepController.setStep(parseInt(this.dataset.step));
    navController.setNavToComplete();
    navController.setNavToActive(parseInt(this.dataset.step));
  });

  $('.cart-items').on('click', '.complete-edit-button', function () {
    const step = parseInt($(this).data('step'));
    stepController.setStep(step);
    collectionController.goBackToEdit();
    collectionController.changeCollection();
  });

  $('#review-items-wrapper').on('click', '.complete-edit-button', function () {
    const step = parseInt($(this).data('step'));
    stepController.setStep(step);
    collectionController.goBackToEdit();
    collectionController.changeCollection();
  });

  $('#cart-restart-link').click(resetAll);

  $('.collection-product-add').click(function () {
    let selectedProductId = this.dataset.productId;
    let selectedStep = parseInt(this.dataset.step);

    stateProxy.items = stateProxy.items
      .filter(item => parseInt(item.step) !== selectedStep)
      .sort((a, b) => a.step - b.step);

    let productIds = stateProxy.items.map(item => item.productId);

    if (productIds.includes(selectedProductId)) {
      stateProxy.items = stateProxy.items.filter(item => item.productId !== selectedProductId);
      deselectProductButton(this);
    } else {
      stateProxy.items = [...stateProxy.items, this.dataset].sort((a, b) => a.step - b.step);
      selectProductButton(this);
    }

    $('.collection-product-add[data-step="' + selectedStep + '"]').each(function () {
      if (this.dataset.productId !== selectedProductId) {
        deselectProductButton(this);
      }
    });

    if (stateProxy.items.length === stateProxy.totalSteps) return;

    const nextStep = findNextAvailableStep(stateProxy.items, stateProxy.totalSteps);
    stepController.setStep(nextStep);
  });

  function resetAll() {
    $('.floating-text-custom-bundles, .collection-outer-custom-bundles').removeClass('d-none');
    $('.dot-list-wrapper').removeClass('d-none');
    $('#review-page').addClass('hidden-collection');
    $('.content-wrapper').removeClass('complete');

    setTimeout(() => {
      $('#review-page').addClass('d-none');
      $('.collection-wrapper, .floating-text').removeClass('hidden-collection');
      stateProxy.items = [];
      stepController.setStep(1);
    }, 250);

    $('.dot-custom-bundles').removeClass("active complete");
    $('.collection-product-add').removeClass("selected").text("SELECT");
  }

  function findNextAvailableStep(items, totalSteps) {
    const taken = new Set(items.map(i => parseInt(i.step)));
    for (let step = 1; step <= totalSteps; step++) {
      if (!taken.has(step)) return step;
    }
    return null;
  }

  function selectProductButton(el) {
    $(el).addClass('selected').text("ADDED TO KIT");
  }

  function deselectProductButton(el) {
    $(el).removeClass('selected').text("SELECT");
  }

  $('.add-to-cart').click(function () {
    const productIds = state.items.map(x => x.productId);
    addToCart(productIds);
  });

  function addToCart(productIds) {
    const currentTime = Date.now();
    const bundleIdFull = `${bundleId}-${currentTime}`;
    const button = $('.add-to-cart');

    const formData = {
      items: productIds.map(productId => ({
        id: productId,
        quantity: 1,
        properties: {
          _bundleId: bundleIdFull,
          _percentageOffbundle: discount
        }
      }))
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify(formData),
      dataType: "json",
      headers: { "Content-Type": "application/json" },
      beforeSend() {
        button.prop('disabled', true).text("ADDING TO CART...");
      },
      success() {
        if (window.Rebuy?.SmartCart) {
          window.Rebuy.Cart.fetchCart();
          setTimeout(() => window.Rebuy.SmartCart.show(), 300);
        } else {
          $.getJSON("/cart.js", updatedCart => {
            document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: updatedCart } }));
            document.querySelector("#cart-drawer")?.show?.();
          });
        }
      },
      complete() {
        button.prop('disabled', false).text("ADD TO CART");
      },
      error(err) {
        console.log(err);
        button.prop('disabled', false).text("ADD TO CART");
      }
    });
  }
});